export const zLayers = {
    "Modal":1050
}